import { render, staticRenderFns } from "./setrange.vue?vue&type=template&id=4dd2baa2&scoped=true"
import script from "./setrange.vue?vue&type=script&lang=js"
export * from "./setrange.vue?vue&type=script&lang=js"
import style0 from "./setrange.vue?vue&type=style&index=0&id=4dd2baa2&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd2baa2",
  null
  
)

export default component.exports